import React from 'react'
import { Grid, Typography } from '@mui/material'
import useStyles from './useStyles'
import { EditModule } from '../../../../components/Modals/Instances/Modules/EditModule'
import { DisabledModule } from '../../../../components/Modals/Instances/Modules/DisabledModule'
import { AddModuleModal } from '../../../../components/Modals/Instances/Modules/AddModule'
// import { FullEnabled } from '../../../../components/Modals/Instances/Modules/FullEnabled'
export const BoxModules = ({ modules = [] }) => {
  const classes = useStyles()

  const formatDate = (date) => {
    let formattedDate

    if (date) {
      const newDate = new Date(date)
      formattedDate =
        newDate.getUTCDate() +
        '/' +
        (newDate.getUTCMonth() + 1) +
        '/' +
        newDate.getUTCFullYear()
    }

    return formattedDate
  }

  return (
    <Grid container className={classes.boxDetails}>
      <Grid
        item
        xs={12}
        style={{
          display: ' flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <Typography
          style={{
            fontSize: 20,
            fontWeight: 'bold',
            color: '#4B4952',
            paddingLeft: 10,
            borderBottom: '1px solid rgba(36, 55, 143, 0.2)'
          }}
        >
          Módulos habilitados
        </Typography>
        {/* <FullEnabled /> */}
        <AddModuleModal modules={modules} />
      </Grid>
      {modules &&
        modules.map((item) => (
          <Grid key={item.appModuleId} container style={{ padding: 10 }}>
            <Grid item xs={8}>
              <Typography
                style={{
                  fontSize: 16,
                  fontWeight: 'bold',
                  color: '#485450'
                }}
              >
                {item.appModuleName}
              </Typography>
              <div style={{ display: 'flex' }}>
                <Typography
                  style={{
                    fontSize: 13,
                    fontWeight: 'bold',
                    color: '#6e7a76'
                  }}
                >
                  {formatDate(item.startDate)} -{' '}
                  {formatDate(item.finishDate) ||
                    'Fecha de finalización no definida'}
                </Typography>
              </div>
            </Grid>
            <Grid
              item
              xs={4}
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center'
              }}
            >
              {item.finishDate && new Date(item.finishDate) < new Date()
                ? (
                <button className={classes.buttonEnabledModule}>
                  <Typography
                    className={classes.typographyButton}
                    style={{ color: '#6e7a76' }}
                  >
                    Deshabilitado
                  </Typography>
                </button>
                  )
                : (
                <>
                  <EditModule module={item} />
                  <DisabledModule module={item} />
                </>
                  )}
            </Grid>
          </Grid>
        ))}
    </Grid>
  )
}
